"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _VirtualBackgroundUpload = require("./VirtualBackgroundUpload.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _utils = require("../../../utils");
var _containers = require("../../../containers");
var _constants = require("@studio/constants");
var _metrics = require("@studio/metrics");
var _Reusable = require("../../../constants/Reusable");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function VirtualBackgroundUpload(_ref) {
  var uploadUserVirtualBackground = _ref.uploadUserVirtualBackground,
    virtualBackground = _ref.virtualBackground,
    deleteUserVirtualBackground = _ref.deleteUserVirtualBackground,
    resetUserVirtualBackground = _ref.resetUserVirtualBackground,
    isCustomBackgroundProcessing = _ref.isCustomBackgroundProcessing;
  var inputFile = (0, _react.useRef)(null);
  var uploadZone = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isFileDragOver = _useState2[0],
    setIsFileDragOver = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    errorFile = _useState4[0],
    setErrorFile = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isUploading = _useState6[0],
    setIsUploading = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    uploadedFileName = _useState8[0],
    setUploadedFileName = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    isDeleting = _useState10[0],
    setIsDeleting = _useState10[1];
  var _useBackgroundFilterP = (0, _metrics.useBackgroundFilterPageActionsApi)(),
    startAttendeeUploadedUserBackground = _useBackgroundFilterP.startAttendeeUploadedUserBackground,
    endAttendeeUploadedUserBackground = _useBackgroundFilterP.endAttendeeUploadedUserBackground;
  var _ref2 = virtualBackground || {},
    imageURL = _ref2.imageURL,
    fileName = _ref2.fileName,
    isUploadFailed = _ref2.isUploadFailed;
  var isBackgroundUploaded = !!imageURL;
  var fileNameRef = (0, _react.useRef)(null);
  var backgroundUploadSuccessful = isBackgroundUploaded && isUploading;
  if (backgroundUploadSuccessful) {
    endAttendeeUploadedUserBackground();
    setIsUploading(false);
  }
  (0, _react.useEffect)(function () {
    if (isBackgroundUploaded) {
      fileNameRef.current.focus();
      setIsDeleting(false);
    }
    if (virtualBackground !== null && virtualBackground !== void 0 && virtualBackground.isDeleteFailed) {
      setIsDeleting(false);
    }
    if (!isBackgroundUploaded) {
      setIsDeleting(false);
    }
  }, [isBackgroundUploaded, virtualBackground === null || virtualBackground === void 0 ? void 0 : virtualBackground.isDeleteFailed]);
  (0, _react.useEffect)(function () {
    if (isUploadFailed) {
      endAttendeeUploadedUserBackground({
        error: "Error uploading virtual background"
      });
      setIsUploading(false);
      setErrorFile({
        name: uploadedFileName,
        errors: [_constants.UPLOAD_VIRTUAL_BACKGROUND_FAILURE_MSG]
      });
      resetUserVirtualBackground();
    }
  }, [isUploadFailed]);
  var handleFileChange = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(files) {
      var file, errors;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setErrorFile(null);
            if (!(files.length > 1)) {
              _context.next = 6;
              break;
            }
            console.warn(_constants.ERROR_TITLE, _constants.ERROR_DESCRIPTION);
            setErrorFile({
              name: 'Multiple Files...',
              errors: [_constants.ERROR_DESCRIPTION]
            });
            setIsFileDragOver(false);
            return _context.abrupt("return");
          case 6:
            file = files[0];
            setUploadedFileName(file.name);
            _context.next = 10;
            return (0, _utils.validateVirtualBackgroundUpload)(file, files[0].length);
          case 10:
            errors = _context.sent;
            if (!(errors.length > 0)) {
              _context.next = 16;
              break;
            }
            console.warn(_constants.ERROR_TITLE, {
              name: file.name,
              error: errors
            });
            setErrorFile({
              name: file.name,
              errors: errors
            });
            setIsFileDragOver(false);
            return _context.abrupt("return");
          case 16:
            setIsUploading(true);
            startAttendeeUploadedUserBackground({
              fileName: file.name,
              fileSize: file.size
            });
            uploadUserVirtualBackground(file);
            setIsFileDragOver(false);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleFileChange(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  function handleButtonClick() {
    inputFile.current.click();
    uploadZone.current.focus();
  }
  function handleDragOver(event) {
    event.preventDefault();
    if (isBackgroundUploaded || isUploading) {
      event.preventDefault();
      setIsFileDragOver(false);
      return;
    }
    setIsFileDragOver(true);
  }
  function handleDrop(event) {
    event.preventDefault();
    if (isBackgroundUploaded || isUploading) {
      setIsFileDragOver(false);
      return;
    }
    var droppedFiles = event.dataTransfer.files;
    if (!droppedFiles.length) {
      setIsFileDragOver(false);
    } else {
      handleFileChange(droppedFiles);
    }
  }
  function removeFile() {
    var _uploadZone$current2;
    if (isDeleting) return;
    if (errorFile) {
      var _uploadZone$current;
      setErrorFile(null);
      setIsUploading(false);
      (_uploadZone$current = uploadZone.current) === null || _uploadZone$current === void 0 ? void 0 : _uploadZone$current.focus();
      return;
    }
    setIsDeleting(true);
    deleteUserVirtualBackground();
    setIsUploading(false);
    (_uploadZone$current2 = uploadZone.current) === null || _uploadZone$current2 === void 0 ? void 0 : _uploadZone$current2.focus();
  }
  var isErrorState = !!errorFile;
  var uploadZoneContent;
  if (isBackgroundUploaded) {
    uploadZoneContent = _react["default"].createElement(_VirtualBackgroundUpload.FileDetailWrapper, {
      ref: fileNameRef,
      tabIndex: 0,
      "aria-disabled": isCustomBackgroundProcessing
    }, _react["default"].createElement(_VirtualBackgroundUpload.FileNameLabel, {
      "aria-label": "Uploaded file: ".concat(fileName)
    }, fileName), _react["default"].createElement(_VirtualBackgroundUpload.DeleteIconWrapper, {
      tabIndex: 0,
      "aria-label": "Delete",
      onKeyDown: function onKeyDown(e) {
        return (0, _Reusable.handleEnterDown)(e, removeFile);
      },
      onClick: removeFile,
      "data-testid": "deleteFileIcon"
    }, _react["default"].createElement(_VirtualBackgroundUpload.DeleteIcon, {
      icon: _freeSolidSvgIcons.faXmark
    })));
  } else if (isErrorState) {
    uploadZoneContent = _react["default"].createElement(_containers.VirtualBackgroundUploadError, {
      id: "virtualBackgroundUploadError",
      role: "alert",
      errorFile: errorFile,
      removeFile: removeFile
    });
  } else {
    uploadZoneContent = _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_VirtualBackgroundUpload.UploadInfoText, {
      id: "uploadInstructions"
    }, _constants.UPLOAD_INFO.SUPPORTED_FILE_TYPES, _react["default"].createElement("br", null), _constants.UPLOAD_INFO.RECOMMENDED_SIZE), _react["default"].createElement("label", {
      id: "virtualFileLabel",
      htmlFor: "virtualBackgroundFile",
      className: "sr-only",
      "aria-hidden": "true"
    }, "Upload Virtual Background"), _react["default"].createElement(_VirtualBackgroundUpload.HiddenInputFile, {
      type: "file",
      id: "virtualBackgroundFile",
      accept: ".png, .jpeg, .jpg",
      onChange: function onChange(e) {
        handleFileChange(e.target.files);
      },
      name: "file",
      "data-testid": "virtualBackgroundFileInput",
      ref: inputFile
    }), _react["default"].createElement(_VirtualBackgroundUpload.StyledButton, {
      disabled: isFileDragOver || isUploading,
      onClick: handleButtonClick,
      "data-testid": "virtualBackgroundButtonInput",
      isUploading: isUploading
    }, _react["default"].createElement(_VirtualBackgroundUpload.ButtonContentWrapper, null, _react["default"].createElement(_VirtualBackgroundUpload.UploadIconWrapper, null, _react["default"].createElement(_VirtualBackgroundUpload.UploadIcon, {
      icon: isUploading ? _freeSolidSvgIcons.faSpinner : _freeSolidSvgIcons.faUpload,
      spin: isUploading,
      isUploading: isUploading
    })), _react["default"].createElement(_VirtualBackgroundUpload.UploadText, {
      isUploading: isUploading
    }, "Upload"))));
  }
  return _react["default"].createElement(_VirtualBackgroundUpload.UploadZone, {
    ref: uploadZone,
    "data-testid": "virtualBackgroundUploadZone",
    onDragOver: handleDragOver,
    onDrop: handleDrop,
    onDragEnter: function onDragEnter() {
      return setIsFileDragOver(true);
    },
    onDragLeave: function onDragLeave() {
      return setIsFileDragOver(false);
    },
    isFileDragOver: isFileDragOver,
    isBackgroundUploaded: isBackgroundUploaded,
    tabIndex: 0,
    isError: isErrorState,
    "aria-describedby": isErrorState ? 'virtualBackgroundUploadError' : null
  }, uploadZoneContent);
}
VirtualBackgroundUpload.propTypes = {
  uploadUserVirtualBackground: _propTypes["default"].func,
  virtualBackground: _propTypes["default"].object,
  deleteUserVirtualBackground: _propTypes["default"].func,
  resetUserVirtualBackground: _propTypes["default"].func,
  isCustomBackgroundProcessing: _propTypes["default"].bool
};
var _default = exports["default"] = VirtualBackgroundUpload;